import { ReactNode } from 'react';

import { Typography, makeStyles, styled } from '@material-ui/core';

import classNames from 'classnames';

import { RichOverflowTooltipMui } from '../RichOverflowTooltip';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarValueWrapper and delete. */
export const SidebarValueWrapperMui = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  '& + *': {
    marginTop: theme.spacing(3),
  },
}));

const useStyles = makeStyles(theme => ({
  outerGrid: {
    display: 'grid',
    columnGap: theme.spacing(1),
    alignItems: 'self-start',
    color: theme.palette.text.secondary,
    gridTemplateColumns: '1fr',
  },
  iconGrid: {
    gridTemplateColumns: 'max-content 1fr',
  },
  textGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    minWidth: 0,
    overflowWrap: 'break-word',
  },
}));

export type SidebarValueMuiProps = {
  name: string;
  value?: ReactNode;
  icon?: ReactNode;
  singleLine?: boolean;
  popover?: boolean;
  testId?: string;
};

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarValue and delete. */
export const SidebarValueMui = ({
  name,
  value,
  icon,
  singleLine,
  popover,
  testId,
}: SidebarValueMuiProps) => {
  const classes = useStyles();

  return (
    <div
      data-testid={testId}
      className={classNames(classes.outerGrid, { [classes.iconGrid]: !!icon })}
    >
      {icon}
      <div className={classes.textGrid}>
        <Typography
          color={popover ? 'textSecondary' : 'textPrimary'}
          variant="body2"
        >
          {name}
        </Typography>
        {singleLine ? (
          <RichOverflowTooltipMui placement="bottom-start">
            <Typography
              component="span"
              variant="body2"
              color={popover ? 'textPrimary' : 'inherit'}
            >
              {value}
            </Typography>
          </RichOverflowTooltipMui>
        ) : (
          <Typography
            component="div"
            variant="body2"
            color={popover ? 'textPrimary' : 'inherit'}
          >
            {value}
          </Typography>
        )}
      </div>
    </div>
  );
};
